module.exports = __webpack_public_path__ + "static/media/gb.945b8f36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gb.png
// module id = 163
// module chunks = 7